export function update_from_partial(obj, update) {
    return Object.assign(Object.assign({}, obj), update);
}
/**
 * Checks if the given map has an entry for key which is not undefined and returns it.
 * If there is no entry, or it is undefined, sets the entry to value and returns it.
 * @param map the Map for which to do the operation
 * @param key The key at which to set or get the value
 * @param value The value to set if there is no value
 * @returns The value at Key or Value if there was none/undefined
 */
export function get_or_set_map_value(map, key, value) {
    let ret = value;
    ret = map.get(key);
    if (ret === undefined) {
        map.set(key, value);
        ret = value;
    }
    return ret;
}
/**
 * Remove an element, in-place, from array.
 * @param {T} array Array to remove element from
 * @param {T[]} element Element to remove
 * @returns {boolean} True if element was found and removed, false if element wasn't found
 */
export function remove_array_element(array, element) {
    const index = array.indexOf(element);
    if (index < 0) {
        return false;
    }
    array.splice(index, 1);
    return true;
}
export function key_from_value_map(map, value) {
    for (const [map_key, map_value] of map) {
        if (map_value === value) {
            return map_key;
        }
    }
    return undefined;
}
export function is_same(a, b) {
    for (const key in a) {
        if (b[key] !== undefined && b[key] !== a[key]) {
            return false;
        }
    }
    return true;
}
function is_value_primitive(value) {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint' || typeof value === 'undefined' || typeof value === 'symbol') {
        return true;
    }
    else if (value === null) {
        // null is of type object, but we still consider it a primitive
        return true;
    }
    return false;
}
export function deep_equals(a, b, current_depth = 0, max_depth = 10) {
    if (current_depth === max_depth) {
        throw new Error('deep_equals exceeded maximum search depth');
    }
    for (const field in a) {
        // Typescript typeof type narrowing doesnt work properly for T[key] but it does for unknown..
        const a_value = a[field];
        const b_value = b[field];
        if (is_value_primitive(a_value) && a_value !== b_value) {
            return false;
        }
        else if (typeof a_value === 'object' && a_value !== null && typeof b_value === 'object' && b_value !== null) {
            // See if objects are equal in value defenition
            if (!deep_equals(a_value, b_value, current_depth + 1, max_depth)) {
                return false;
            }
        }
    }
    return true;
}
//# sourceMappingURL=utils.js.map